import { delete as del, get, post } from 'axios';

export const createBasket = async bookingRef => {
  const { data } = await post(`/api/basket/${bookingRef}`);

  return {
    bookingRef,
    basket: data.basket,
  };
};

export const getBasket = async bookingRef => {
  const { data } = await get(`/api/basket/${bookingRef}`);

  return {
    bookingRef,
    basket: data?.basket,
  };
};

export const getBasketStatus = async bookingRef => {
  const { data } = await get(`/api/basket/${bookingRef}/status`);

  return {
    bookingRef,
    status: data.status,
  };
};

export const getBasketPaymentsStatus = async bookingRef => {
  const { data } = await get(`/api/basket/${bookingRef}/payments/status`);

  return {
    bookingRef,
    payments: data?.payments ?? [],
  };
};

export const addTransportToBasket = async (bookingRef, transport) => {
  const { data } = await post(`/api/basket/${bookingRef}/transport`, {
    transport,
  });

  return {
    bookingRef,
    transport: data.transport,
  };
};

export const removeTransportFromBasket = async (bookingRef, transportId) => {
  const { data } = await del(
    `/api/basket/${bookingRef}/transport/${transportId}`,
  );

  return {
    data,
  };
};

export const addNameChangeToBasket = async (bookingRef, nameChange) => {
  const { data } = await post(`/api/basket/${bookingRef}/ticketdetailchange`, [
    nameChange,
  ]);

  return {
    bookingRef,
    nameChange: data.nameChange,
  };
};

export const removeNameChangeFromBasket = async (bookingRef, nameChangeId) => {
  const { data } = await del(
    `/api/basket/${bookingRef}/charge/${nameChangeId}`,
  );

  return {
    data,
  };
};

export const addExtraToBasket = async (bookingRef, extras) => {
  const { data } = await post(`/api/basket/${bookingRef}/extra`, { extras });

  return {
    bookingRef,
    extras: data.extras,
  };
};

export const removeExtraFromBasket = async (bookingReference, extraId) => {
  const { data } = await del(
    `/api/basket/${bookingReference}/extra/${extraId}`,
  );

  return {
    data,
  };
};

export const addTicketsToBasket = async (bookingRef, tickets) => {
  const { data } = await post(`/api/basket/${bookingRef}/tickets`, { tickets });

  return {
    bookingRef,
    errors: data.errors,
    tickets: data.tickets,
  };
};

export const removeTicketFromBasket = async (bookingRef, ticketId) => {
  const { data } = await del(`/api/basket/${bookingRef}/tickets/${ticketId}`);

  return {
    data,
  };
};

export const addAccommodationToBasket = async (bookingRef, accommodations) => {
  const { data } = await post(`/api/basket/${bookingRef}/accommodation`, {
    accommodations,
  });

  return {
    bookingRef,
    accommodations: data.accommodations,
    errors: data?.errors ?? null,
  };
};

export const removeAccommodationFromBasket = async (bookingRef, accoId) => {
  const { data } = await del(
    `/api/basket/${bookingRef}/accommodation/${accoId}`,
  );

  return {
    data,
  };
};

export const addAccommodationExtraToBasket = async (bookingRef, extras) => {
  const added = [];

  let index = 0;
  while (index < extras.length) {
    const { data } = await post(
      `/api/basket/${bookingRef}/accommodation/${extras[index].acco_id}/extra`,
      {
        extras: extras[index],
      },
    );

    if (data.errors) {
      return {
        errors: data.errors,
      };
    }
    added.push(data.extras);
    index += 1;
  }

  return {
    bookingRef,
    added,
  };
};

export const completeBasket = async bookingRef => {
  const { data } = await post(`/api/basket/${bookingRef}/complete`, {});

  return {
    data,
  };
};

export const deleteBasket = async bookingRef => {
  const { data } = await del(`/api/basket/${bookingRef}`);

  return {
    data,
  };
};

export const addPaxToBasket = async (bookingRef, pax) => {
  const { data } = await post(`/api/basket/${bookingRef}/pax`, { pax });

  return {
    bookingRef,
    pax: data.pax,
  };
};

export const removePaxFromBasket = async (bookingReference, paxId) => {
  const { data } = await del(`/api/basket/${bookingReference}/pax/${paxId}`);

  return {
    data,
  };
};
